export const DEBUG = true;
export const GRAMJS_SESSION_ID_KEY = 'GramJs:sessionId';
export const TDLIB_SESSION_ID_KEY = 'TdLib:sessionId';
